import { Box, SectionHelper, Text } from '@wix/design-system';
import { InfoCircleSmall } from '@wix/wix-ui-icons-common';
import React, { useContext, useState } from 'react';

import { RicosContext } from './../../../ricos-context';

const LS_KEY = 'ricos/color-picker/live-site-color-hint/closed';

export const ColorPickerLiveSiteColorHint: React.FC = () => {
  const { t } = useContext(RicosContext);

  const [isClosed, setIsClosed] = useState<boolean>(() => !!localStorage?.getItem(LS_KEY));

  const onClose = () => {
    localStorage?.setItem(LS_KEY, 'true');
    setIsClosed(true);
  };

  if (isClosed) {
    return null;
  }

  return (
    <Box>
      <SectionHelper appearance="standard" onClose={onClose} size="small" showCloseButton>
        <Box direction="horizontal" gap="SP1">
          <Text>
            <InfoCircleSmall />
          </Text>
          <Text size="tiny" weight="thin">
            {t('ColorPickerLiveSiteColorHint')}
          </Text>
        </Box>
      </SectionHelper>
    </Box>
  );
};
